module.exports = __webpack_public_path__ + "static/media/Write-Off-Disposal.6f138b8f.svg";